import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Container,
  Button,
  Typography,
  Box,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  InputAdornment,
  FormLabel,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";

const ReferenciasLaboralesForm = ({
  open,
  onClose,
  isEditMode,
  id_candidato,
  mostrarAlertaTemporal,
  obtenerReferencias,
  props,
}) => {
  const [formValues, setFormValues] = useState({
    id: isEditMode ? props.id : undefined,
    id_candidato: id_candidato,
    nombre_referenciador: isEditMode ? props.nombre_referenciador : "",
    mail: isEditMode ? props.mail : "",
    telefono: isEditMode ? props.telefono : "",
    evaluacion_general: isEditMode ? props.evaluacion_general : "",
    puesto_y_responsabilidades: isEditMode
      ? props.puesto_y_responsabilidades
      : "",
    motivo_salida: isEditMode ? props.motivo_salida : "",
    relacion_con_candidato: isEditMode ? props.relacion_con_candidato : "",
    tiempo_trabajado: isEditMode ? props.tiempo_trabajado : "",
    user: localStorage.getItem("user"),
    habilidades_y_competencias: isEditMode
      ? props.habilidades_y_competencias
      : "",
  });

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //Validaciones
    if (
      formValues.nombre_referenciador.trim() === "" ||
      formValues.mail.trim() === "" ||
      formValues.telefono.trim() === "" ||
      formValues.evaluacion_general.trim() === "" ||
      formValues.puesto_y_responsabilidades.trim() === "" ||
      formValues.habilidades_y_competencias.trim() === "" ||
      formValues.relacion_con_candidato.trim() === "" ||
      formValues.tiempo_trabajado.trim() === ""
    ) {
      mostrarAlertaTemporal(
        "Por favor, complete todos los datos del formulario antes de enviar",
        "error"
      );
      return;
    }
    const url = isEditMode
      ? `${UrlApi}/SP_referencias/${props.id}`
      : `${UrlApi}/SP_referencias`;
    const method = isEditMode ? "PUT" : "POST";

    try {
      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formValues),
      });

      if (!response.ok) {
        const error = await response.json();
        mostrarAlertaTemporal(`Error: ${error.message}`, "error");
      } else {
        mostrarAlertaTemporal(
          isEditMode
            ? "Referencia laboral actualizada correctamente"
            : "Referencia laboral creada con exito",
          "success"
        );
        obtenerReferencias();

        onClose();
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      mostrarAlertaTemporal("Ocurrio un error inesperado", "error");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <Box sx={{ backgroundColor: "#1F618D", marginBottom: 4 }}>
        <DialogTitle>
          <Typography variant="h6" align="center" color="#fff">
            {isEditMode
              ? "Editar referencia laboral"
              : "Nueva referencia laboral"}
          </Typography>
        </DialogTitle>
      </Box>
      <Box sx={{ maxHeight: "60vh", overflowY: "auto", padding: 2 }}>
        <form onSubmit={handleSubmit} className="p-4">
          <Grid container spacing={2}>
            {[
              {
                name: "nombre_referenciador",
                label: "Nombre",
                description:
                  "Es importante saber quién está proporcionando la referencia para validar su autenticidad y puesto que ocupa en la empresa.",
                maxLength: 60,
              },
              {
                name: "mail",
                label: "Correo",
                description: "Ingrese su correo electrónico",
                maxLength: 70,
              },
              {
                name: "telefono",
                label: "Teléfono",
                description: "Ingrese su número de contacto",
                maxLength: 20,
              },
              {
                name: "puesto_y_responsabilidades",
                label: "Puesto y responsabilidades",
                description:
                  " Detalles sobre el puesto que ocupaba el candidato y sus responsabilidades específicas.",
                maxLength: 300,
              },
              {
                name: "habilidades_y_competencias",
                label: "Habilidades y competencias",
                description:
                  " Información sobre las habilidades y competencias del candidato, incluyendo ejemplos específicos de su desempeño.",
                maxLength: 300,
              },
              {
                name: "motivo_salida",
                label: "Motivo de salida",
                description:
                  "Si es posible, obtener información sobre por qué el candidato dejó su anterior empleo.",
                maxLength: 80,
              },
              {
                name: "relacion_con_candidato",
                label: "Relación con el candidato",
                description:
                  "Debes clarificar cómo conoce el referenciador al candidato y en qué contexto han trabajado juntos.",
                maxLength: 200,
              },
              {
                name: "tiempo_trabajado",
                label: "Tiempo trabajado",
                description:
                  "Cuánto tiempo han trabajado juntos para entender mejor la experiencia del candidato.",
                maxLength: 20,
              },
              {
                name: "evaluacion_general",
                label: "Evaluacion general",
                description:
                  "Una evaluación general del desempeño del candidato, incluyendo puntos fuertes y áreas de mejora.",
                maxLength: 500,
              },
            ].map((field, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <FormControl fullWidth margin="normal">
                  <FormLabel sx={{ fontWeight: "bold" }}>
                    {field.label}
                  </FormLabel>
                  <Typography
                    variant="body2"
                    color="gray"
                    sx={{ fontSize: "0.8rem" }}
                  >
                    {field.description}
                  </Typography>
                  <TextField
                    fullWidth
                    name={field.name}
                    value={formValues[field.name]}
                    onChange={handleChange}
                    inputProps={
                      field.maxLength > 0 ? { maxLength: field.maxLength } : {}
                    }
                  />
                  {field.maxLength && (
                    <Typography variant="body2" color="textSecondary">
                      {formValues[field.name]?.length || 0} / {field.maxLength}{" "}
                      caracteres
                    </Typography>
                  )}
                </FormControl>
              </Grid>
            ))}
          </Grid>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button onClick={onClose} sx={{ mr: 1 }}>
              Volver
            </Button>
            <Button type="submit" variant="contained">
              Enviar
            </Button>
          </Box>
        </form>
      </Box>
    </Dialog>
  );
};

export default ReferenciasLaboralesForm;
